import "../static/css/main";
// import "../static/css/zencheng.less";
// import "../static/css/zTreeStyle/zTreeStyle.css";
// import "../components/public/accordion/accordion.less";
import React from "react";
import { render } from "react-dom";
import { Router, hashHistory } from "react-router";
import { ConfigProvider, message } from "antd";
import zhCN from "antd/lib/locale-provider/zh_CN";
import { getSessionAccount } from "api/api";
import { getAccountResources } from "api/settingsApi";
import { sources as AjaxList } from "utils/http";
import permission from "utils/authCheck";
import SystemActions from "actions/system-actions";
import UserActions from "actions/user-actions";
// eslint-disable-next-line import/no-extraneous-dependencies
import "@babel/polyfill";
import { getAuthArray, getHost } from "utils/tool";
import Tools from "utils/tools";
import { handleEnv } from "utils/tool";
import { setInitData } from 'het-sign-img';//appId: 31038
//env 如果不传默认是正式环境 (0 测试环境 1 预发布环境 2 线上环境)
// console.log("handleEnv",handleEnv())
setInitData({ appId: '31038',env:handleEnv()});

const nomatch = require("../routes/NoMatch");
const login = require("../routes/login");
// const main = require("../routes/main");
// const workSpace = require("../routes/workSpace");
const screen = require("../routes/screen");

message.config({
  top: 100,
  duration: 2,
  maxCount: 1
});

// 取消ajax请求
function cancelAjax(nextState, prevState) {
  if (!prevState) return false;
  const reg = /\/form$/;
  if (
    nextState.location.pathname === encodeURI(prevState.location.pathname) ||
    nextState.location.pathname === prevState.location.pathname
  ) {
    console.log("url 相同");
    return false;
  }
  if (!reg.test(nextState.location.pathname)) {
    if (AjaxList.length > 0) {
      console.table("AjaxList", AjaxList);
      AjaxList.forEach(item => {
        console.dir("AjaxList", item);
        item();
      });
      AjaxList.length = 0;
    }
  }
}
// 错误处理
function errorHandle() {
  message.error("获取当前账号权限错误,请刷新页面,重新登录");
  setTimeout(() => {
    Tools.delCookie("userInfo");
    sessionStorage.removeItem("allAuthArray");
    sessionStorage.removeItem("allAuthCodeObj");
    sessionStorage.removeItem("bigConfig");
    // hashHistory.replace("/farm");
    window.location.reload();
  }, 1000);
}
// 路由权限校验
// todo 需整理
async function authCheck(nextState, callback, prevState) {
  const userInfo = Tools.getCookie("userInfo");
  // 账号登录判断
  if (!userInfo) {
    console.log("普通账号未登录");
    // 清理session cookies过期 如果不关闭浏览器
    // todo sessionStorage 设置和cookies一样过期时间
    UserActions.clearUserInfo();
    if (nextState.location.pathname !== "/farm") {
      hashHistory.replace("/farm");
    } else {
      // cancelAjax(nextState, prevState);
      callback();
    }
  } else {
    console.log("普通账号已登录");
    const locationSearch = sessionStorage.getItem("locationSearch");
    const nowLocationSearch = window.location.search
      .split("?")
      .pop()
      .toLocaleLowerCase();
    if (locationSearch !== nowLocationSearch) {
      // 处理定义登录及主线登录BUG
      Tools.delCookie("userInfo");
      sessionStorage.clear();
      getHost(true);
      window.location.reload(true);
      return;
    }
    if (
      nextState.location.pathname === "/farm" ||
      nextState.location.pathname === "/"
    ) {
      const bigConfig = sessionStorage.getItem("bigConfig")
        ? JSON.parse(sessionStorage.getItem("bigConfig"))
        : {};
      // 根据bigConfig信息，设置进入的链接 直接进入大屏还是后台管理系统
      /* if (bigConfig.firstInBig !== 1) {
        hashHistory.replace("/main/plant/index");
      } else {
        hashHistory.replace("/linyin");
      } */
      hashHistory.replace("/screen/home");
    } else {
      cancelAjax(nextState, prevState);

      let allAuthArray = sessionStorage.getItem("allAuthArray");
      if (allAuthArray) {
        allAuthArray = JSON.parse(allAuthArray);
      } else {
        try {
          const res = await getAccountResources(); // 资源管理权限，菜单列表
          allAuthArray = getAuthArray(res.data);
          sessionStorage.setItem(
            "allAuthArray",
            JSON.stringify(allAuthArray.array)
          );
          sessionStorage.setItem(
            "allAuthCodeObj",
            JSON.stringify(allAuthArray.objCode)
          );
          sessionStorage.setItem(
            "allAuthCodePrentId",
            JSON.stringify(allAuthArray.codePrentId)
          );
          SystemActions.updateAllAuthArray(
            allAuthArray.array,
            allAuthArray.objCode,
            allAuthArray.codePrentId
          );
        } catch (err) {
          if (!err.isCancel) errorHandle();
          return false;
        }
      }
      // 2019.3.20 todo
      console.log("路由检查");
      if (permission.routerCheck(nextState)) {
        callback();
      } else {
        message.error("没有权限");
      }
    }
  }
}
// 根路由树
const rootRoute = {
  path: "/",
  // childRoutes: [main, login, workSpace, linyin, nomatch ],
  childRoutes: [screen, login, nomatch],
  onEnter(nextState, replaceState, callback) {
    console.log("onEnter");
    authCheck(nextState, callback);
    // callback();
  },
  onChange(prevState, nextState, replaceState, callback) {
    console.log("onChange", prevState, nextState);
    authCheck(nextState, callback, prevState);
    // callback();
  }
};

const routers = (
  <ConfigProvider locale={zhCN}>
    <Router routes={[rootRoute]} history={hashHistory} />
  </ConfigProvider>
);
// console.log("MODULES", MODULES);
render(routers, document.getElementById("container"));

// if (process.apiName && process.apiUrl) {
//   console.log(`目前代理的环境是：${process.apiName}`);
//   console.log(`目前代理的网址是：${process.apiUrl}`);
// }
